module.exports = __webpack_public_path__ + "static/media/black-unchecked.fd356ec4.svg";